import ScrollView from './scroll-view/ScrollView';
export default {
  install: (Vue) => {
    Vue.component(ScrollView.name, ScrollView);
  }
}